import React from 'react';
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'modules';
import MenteeMyPage from 'components/mentoring/mentee/MenteeMyPage';
import MentorMyPage from 'components/mentoring/mentor/MentorMyPage';
import { CMentoringFieldType } from 'constants/mentoring.const';
import { EUserType } from 'enums/base.enum';

const MentoringMyPage = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  return (
    <>
      <Helmet>
        <title>
          {currentUser?.primary_field && CMentoringFieldType[currentUser?.primary_field]} - 나의 멘토링 관리
        </title>
      </Helmet>

      {currentUser?.user_type === EUserType.Mentee ? (
        <MenteeMyPage user={currentUser} />
      ) : (
        <MentorMyPage user={currentUser} />
      )}
    </>
  );
};

export default MentoringMyPage;
